import React, { Component } from 'react';
import { Grid, Typography,Zoom, Switch, TextField, Button, MenuItem, StepContent, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress } from '@material-ui/core';

import { Done, ErrorOutline} from '@material-ui/icons';

import FlightStageService from '../../tools/FlightStageService';
//msgs
import { msgAction, msgSimple,msgError } from '../../actions/snackbarActions';
import { connect } from 'react-redux';

class SendEmailAlert extends Component {
    constructor(props) {
        super(props)
        this.state = {
            sentEmail:false,
            error:true,
            done:false

        }
    }

    componentWillMount() {
        this.setState({
            sentEmail:false,
            error:true,
            done:false
        })
    }

    sendEmail = async ()=>{
        this.setState({loadingEmail:true})
        FlightStageService.sendEmail(this.props.missionId,this.props.id).then(async response=>{
            if(response.ok){
                // console.log(response)
                await this.setState({loadingEmail:false})
                await this.setState({error:false})
                await this.setState({sentEmail:true})
                await this.setState({done:true})
                // let time3 = setInterval(() => {
                    //     clearInterval(time3)
                    // }, 200);
                    // let time2 = setInterval(() => {
                        //     clearInterval(time2)
                        // }, 200);
                        // let time4 = setInterval(() => {
                            //     clearInterval(time4)
                            // }, 200);
                            
                let time = setInterval(() => {
                    this.props.close()
                    clearInterval(time)
                }, 700);
            }
            else{
                await this.setState({loadingEmail:false})
                await this.setState({error:false})
                await this.setState({sentEmail:true})
                await this.setState({sentEmail:false})
                await this.setState({error:true})
                await this.props.msgError('É necessário preencher os campos obrigatórios da missão.')
                // await this.props.close()
                // this.setState({dialogEmail:true,sentEmail:false})
                // let time3 = setInterval(() => {
                //     this.setState({error:false})
                //     clearInterval(time3)
                // }, 200);
                // let time2 = setInterval(() => {
                //     this.setState({sentEmail:true})
                //     clearInterval(time2)
                // }, 200);
                //  time2 = setInterval(() => {
                //     this.setState({sentEmail:false})
                //     clearInterval(time2)
                // }, 200);
                // let time4 = setInterval(() => {
                //     this.setState({error:true})
                //     clearInterval(time4)
                // }, 200);
            }
        })
    }

    render(){
        return(
            <Dialog
                open={this.props.open}
                onEnter={()=>{
                    this.setState({
                        sentEmail:false,
                        error:true,
                        done:false
                    })
                }}
                maxWidth='sm'
                style={{alignItems:'center'}}
                scroll='body'
                aria-labelledby="form-dialog-title"
            >
                <DialogContent>
                    <Grid container style={{padding:20}}>
                        <Grid container justify={'center'}>
                            <Typography style={{fontSize:32}}>
                                Deseja confirmar o envio do e-mail?
                            </Typography>
                        </Grid>
                        <Grid container justify={'center'}>
                        {this.state.loadingEmail?
                            <CircularProgress size={100}/>
                            :<Grid>
                                {this.state.sentEmail ? 
                                    <Zoom in={this.state.done}>
                                        <Done style={{fontSize:120,color:'#3f51b5'}}/>
                                    </Zoom>:
                                    <Zoom in={this.state.error}>
                                        <ErrorOutline style={{fontSize:120,color:'#f50057'}}/>
                                    </Zoom>
                                }
                            </Grid>
                        }
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>this.props.close()} color="secondary">
                        Não Confirmar
                    </Button>
                    <Button onClick={()=>this.sendEmail()} color="primary" autoFocus>
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}


const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {
    msgSimple,
    msgError
};

export default connect(mapStateToProps, mapDispatchToProps)(SendEmailAlert)


// WEBPACK FOOTER //
// ./src/routes/flight/SendEmailAlert.js